import React from 'react';
import { theme } from '../../styles/theme';
import { Modal } from './Modal';
import { Button } from './Button';

interface ComingSoonModalProps {
  isOpen: boolean;
  onClose: () => void;
  feature?: string;
}

/** Informational modal shown when a feature is not yet available. */
export const ComingSoonModal: React.FC<ComingSoonModalProps> = ({
  isOpen,
  onClose,
  feature = 'This feature',
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div style={{ textAlign: 'center', padding: theme.spacing.md }}>
        {/* Rocket Icon */}
        <div
          style={{
            width: '80px',
            height: '80px',
            margin: '0 auto',
            marginBottom: theme.spacing.lg,
            background: `linear-gradient(135deg, ${theme.colors.primary}20, ${theme.colors.secondary}20)`,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke={theme.colors.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
            <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
          </svg>
        </div>

        <h2
          style={{
            fontSize: theme.fontSizes['2xl'],
            fontWeight: theme.fontWeights.bold,
            color: theme.colors.textPrimary,
            marginBottom: theme.spacing.sm,
          }}
        >
          Coming Soon
        </h2>

        <p
          style={{
            fontSize: theme.fontSizes.base,
            color: theme.colors.textSecondary,
            marginBottom: theme.spacing.xl,
            lineHeight: 1.6,
          }}
        >
          {feature} is coming soon. We're working hard to bring you the best experience possible.
        </p>

        <div
          style={{
            background: theme.colors.bgTertiary,
            borderRadius: theme.borderRadius.lg,
            padding: theme.spacing.md,
            marginBottom: theme.spacing.xl,
          }}
        >
          <p
            style={{
              fontSize: theme.fontSizes.sm,
              color: theme.colors.textMuted,
              margin: 0,
            }}
          >
            Stay tuned for updates!
          </p>
        </div>

        <Button
          variant="primary"
          size="md"
          onClick={onClose}
          style={{ width: '100%' }}
        >
          Got it
        </Button>
      </div>
    </Modal>
  );
};

export default ComingSoonModal;
